import React from 'react'
import NoTableData_Kratos from './NoTableData_Kratos'

export default function Table_Kratos(props) {
  let { data, post_fix } = props;

  return (
    <table className="table table-striped">
      <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
        <tr>
          <th scope="col">Vin</th>
          <th scope="col">Value</th>
        </tr>
      </thead>
      <tbody>
        {(data.length == 0) ? <NoTableData_Kratos /> : data.map((x, index) => {
          if (index <= 4) {
            if (x.value === null)
              x.value = 0.00
            x.value = parseFloat(x.value)
            return (<tr key={x.key}>
              <td scope="row" className="hand_geture" onClick={() => props.singleVinSelected(x.key)}>{x.key}
              </td>
              <td>{x.value.toFixed(2)}</td>
            </tr>)
          }
        })}
      </tbody>
    </table>
  )
}
